const $masthead = $('.masthead'),
    classToToggle = 'masthead--sticky';

let stickyTreshold = $masthead.offset().top;

$(window).on('resize', function () {
    stickyTreshold = $masthead.offset().top;
});

window.addEventListener('scroll', function () {
    stickyMasthead();
});

stickyMasthead();

function stickyMasthead () {
    let scrolledDistance = window.scrollY;

    if (scrolledDistance > stickyTreshold) {
        if (!$masthead.hasClass(classToToggle)) {
            $masthead.addClass(classToToggle);
        }
    } else {
        if ($masthead.hasClass(classToToggle)) {
            $masthead.removeClass(classToToggle);
        }
    }
}
